import * as angular from "angular";
import { DivisionDataProvider } from "../../data-provider/division.dp";
import { Campaign } from "../../models/campaign.model";
import { Organisation } from "../../models/organisation.model";
import { OrganisationDataProvider } from "../../data-provider/organisation.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { LimitDataProvider } from "../../data-provider/limit.dp";
import { Limit } from "../../models/limit.model";
import { Division } from "../../models/division.model";

let OrganisationUserLicensesDialogComponent = {
    selector: "vcOrganisationUserLicensesDialog",
    templateUrl:
        "/angular/components/organisation-settings/organisation-user-licenses-dialog.component.html",
    bindings: {
        organisation: "=",
    },
    controller: class OrganisationUserLicensesDialogController {
        // * bindings for typescript compiler *
        public organisation: Organisation;
        // ************************************

        private allocatedSeats: number = 0;
        private availableSeats: number = 0;
        private campaigns: Campaign[] = [];

        private dialog: DialogUtils;
        private toast: ToastUtils;
        private modelsUtils: any;

        private organisationDataProvider: OrganisationDataProvider;
        private limitDataProvider: LimitDataProvider;
        private divisionDataProvider: DivisionDataProvider;

        constructor(
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            OrganisationDataProvider: OrganisationDataProvider,
            LimitDataProvider,
            DivisionDataProvider: DivisionDataProvider,
            ModelsUtils: any
        ) {
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.modelsUtils = ModelsUtils;

            this.organisationDataProvider = OrganisationDataProvider;
            this.limitDataProvider = LimitDataProvider;
            this.divisionDataProvider = DivisionDataProvider;
        }

        $onInit() {
            this.limitDataProvider.get().then((limits: Limit) => {
                this.organisation.limits = limits;
                this.allocatedLicenses();
            });

            this.divisionDataProvider
                .getAllDivisions()
                .then((divisions: Division[]) => {
                    this.organisation.divisions = divisions;
                    this.organisation.divisions[0].expanded = true;
                });
        }

        allocatedLicenses(): void {
            let total = 0;
            this.campaigns = [];
            angular.forEach(this.organisation.divisions, (division) => {
                angular.forEach(division.campaigns, (campaign) => {
                    total += campaign.limits.users;
                    this.campaigns.push(
                        this.modelsUtils.campaign({
                            campaignid: campaign.campaignid,
                            users: campaign.limits.users,
                        })
                    );
                });
            });
            this.allocatedSeats = total;
            this.availableSeats =
                this.organisation.limits.users - this.allocatedSeats;
        }

        addSeat(limits): void {
            limits.users += 1;
            this.allocatedLicenses();
        }

        removeSeat(limits): void {
            limits.users -= 1;
            this.allocatedLicenses();
        }

        save(): void {
            this.organisationDataProvider
                .updateCampaignLimits(this.organisation, this.campaigns)
                .then(
                    () => {
                        this.toast.success("Limits updated");
                        this.dialog.hide();
                    },
                    () => {
                        this.toast.error();
                    }
                );
        }

        dismissDialog(): void {
            this.dialog.cancel();
        }
    },
};

angular
    .module("organisationSettings")
    .component(
        OrganisationUserLicensesDialogComponent.selector,
        OrganisationUserLicensesDialogComponent
    );
